"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Button = function Button(props) {
	var children = props.children,
	    className = props.className,
	    rest = _objectWithoutProperties(props, ["children", "className"]);

	return _react2.default.createElement(
		"div",
		_extends({ className: "button " + className }, rest),
		children
	);
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Button.js
// module id = 243
// module chunks = 0